import Moment from "moment";
import {UUID} from "./calendar.model";

export default class CalendarItem {

    constructor(item) {
        this.uuid = UUID();
        this.id = null;
        this._start = null;
        this._end = null;
        this._duration = null;
        this.title = null;
        this.color = null;
        this.state = null;
        this.data = null;

        if (item) {
            Object.assign(this, item);
        }
    }

    get start() {
        return this._start;
    }

    set start(start) {
        this._start = start ? Moment(start) : null;
        this._duration = null;
    }

    get end() {
        return this._end;
    }

    set end(end) {
        this._end = end ? Moment(end) : null;
        this._duration = null;
    }

    get duration() {
        if (!this._duration && this.start && this.end) {
            this._duration = this.end.diff(this.start, 'minutes');
        }

        return this._duration
    }

    overlapsWith(item) {
        if (Moment(this.start).isBefore(Moment(item.end))
            && Moment(this.end).isAfter(Moment(item.start))) {
            return true;
        } else {
            return false;
        }
    }

    static groupByOverlapping(items) {
        var overlappingById = new Map();

        for (var a = 0; a < items.length; ++a) {
            var itemA = items[a];

            for (var b = a + 1; b < items.length; ++b) {
                var itemB = items[b];

                if (itemA.overlapsWith(itemB)) {
                    var overlapping = overlappingById.get(itemA.uuid) || new Set();
                    overlapping.add(itemA);
                    overlapping.add(itemB);
                    overlappingById.set(itemA.uuid, overlapping);
                    overlappingById.set(itemB.uuid, overlapping);
                }
            }
        }

        var grouped = [];

        overlappingById.forEach(items => {
            grouped.push(Array.from(items));
        });

        return grouped;
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/model/calendar-item.model.js